<div class="box">
  <button type="button" [style]="{'background-color': primaryColor}" (click)="onToogle()">
    {{ group.title }}
  </button>
  <div class="field collapse" [ngClass]="{show: isOpen}" [class.collapse]="true" [class.show]="isOpen" [attr.id]="group.id">
    <ol>
      <li *ngFor="let item of group.items; trackBy: trackByHref">
        <a
          *ngIf="hasHref(item); else previewOnlyItem"
          class="downloadlink"
          [href]="item.href"
          (click)="open(item, $event)"
        >
          {{ item.title }}
        </a>
        <ng-template #previewOnlyItem>
          <button type="button" class="downloadlink downloadlink-button" (click)="open(item)">
            {{ item.title }}
          </button>
        </ng-template>
      </li>
    </ol>
  </div>
</div>
